import React from 'react'
import classNames from 'classnames'
import { Link, LinkProps } from 'react-router-dom'

import '../form/button/Button.less'
import './LinkButton.less'

const LinkButton = (props: Partial<LinkProps> & { light?: boolean }) => {
  const { to, children, onClick, className, light = false } = props
  const cssClasses = classNames('Link Button', className, {
    LightBordered: light
  })
  if (to) {
    return (
      <Link to={to} onClick={onClick} className={cssClasses}>
        {children}
      </Link>
    )
  } else {
    return (
      <a {...props} className={cssClasses}>
        {children}
      </a>
    )
  }
}

export default LinkButton
